'use strict';

import React from 'react';
import PropTypes from 'prop-types';

function Checkbox (props) {
  const id = props.id;
  const checked = !!props.checked;
  const disabled = props.disabled;
  const nextState = !checked;
  const onUpdate = props.onUpdate;

  return (
    <label
      className={'checkbox__box' + (disabled ? ' checkbox__disabled' : '')}
      onClick={(e) => {
        e.preventDefault();
        if (!disabled) {
          onUpdate(id, nextState);
        }
      }}>
      {checked ?
        <span className={'icon-check-box-active-new' + (disabled ? ' checkbox__disabled' : '')}>
          <span className="path1"></span>
          <span className="path2"></span>
        </span>
        :
        <span className={'icon-check-box-new' + (disabled ? ' checkbox__disabled' : '')}></span>
      }
      <span className='checkbox__title'>{ props.label }</span>
    </label>
  );
}

Checkbox.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  label: PropTypes.string.isRequired,
  checked: PropTypes.any,
  onUpdate: PropTypes.func.isRequired,
  disabled: PropTypes.any,
};

Checkbox.defaultProps = {
  id: '',
  checked: false,
  disabled: false
};

export default Checkbox;



// WEBPACK FOOTER //
// ./src/ui/Controls/Checkbox.jsx